import { call, put, select, takeEvery } from 'redux-saga/effects';
import { policiesLoadRequest } from 'actions/policyActions';
import { devicesLoadRequest } from 'actions/deviceActions';
import { reportsLoadRequest } from 'actions/reportActions';
import { deviceGroupsLoadRequest } from 'actions/deviceGroupActions';
import { getTimezoneOffsetCalculator } from 'selectors/serverSelectors';
import { setDate } from 'actions/monitoringActions';
import * as moment from 'moment';
import { isChangeImage } from 'selectors/shellSelectors';


export function* loginSuccessWatcher() {
    yield takeEvery('LOGIN_SUCCESS', afterLoginSaga);
}

export function* afterLoginSaga() {
    yield put(devicesLoadRequest());

    // Can skip loading several things if we're in the Change Image screen
    if (!(yield select(isChangeImage))) {
        yield put(deviceGroupsLoadRequest());
        yield put(policiesLoadRequest());
        yield put(reportsLoadRequest());
    }

    // By the time this saga executes, we've already received timezone info (via server details)
    // Calculate the beginning of 'today' on the server and set that date in our store, which
    // drives the date picker and alarms.
    const tzOffsetCalculator = yield select(getTimezoneOffsetCalculator);
    const utcTime = yield call([ Date, 'now' ]);
    const offset = tzOffsetCalculator(utcTime);
    const date =
        moment.utc(utcTime)
            .utcOffset(offset)
            .startOf('day')
            .toDate();
    yield put(setDate({ date: date, preserveTimeOfDay: false }));
}



// WEBPACK FOOTER //
// ./src/sagas/shell/afterLoginSaga.ts